import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NotificationBell } from '@/components/NotificationBell';

const NavButton = ({ icon, active, center, onClick }) => {
  const strokeColor = active ? '#1A1A2E' : '#8A8798';
  const icons = {
    home: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={strokeColor} strokeWidth={active ? 2 : 1.5}>
        <path d="M3 12l9-9 9 9"/>
        <path d="M5 10v10a1 1 0 001 1h4v-7h4v7h4a1 1 0 001-1V10"/>
      </svg>
    ),
    journal: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={strokeColor} strokeWidth={active ? 2 : 1.5}>
        <path d="M4 4h16v16H4z"/>
        <path d="M8 8h8M8 12h6M8 16h4"/>
      </svg>
    ),
    sage: (
      <div
        className="w-11 h-11 rounded-full flex items-center justify-center -mt-5"
        style={{ backgroundColor: '#1A1A2E', boxShadow: '0 4px 14px rgba(26,26,46,0.25)' }}
      >
        <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#C9A84C' }} />
      </div>
    ),
    progress: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={strokeColor} strokeWidth={active ? 2 : 1.5}>
        <path d="M3 3v18h18"/>
        <path d="M7 16l4-4 4 4 6-6"/>
      </svg>
    ),
    settings: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={strokeColor} strokeWidth={active ? 2 : 1.5}>
        <circle cx="12" cy="12" r="3"/>
        <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>
      </svg>
    ),
  };

  return (
    <button
      onClick={onClick}
      className={`p-2.5 rounded-full transition-colors duration-200 ${center ? '' : 'active:scale-95 hover:bg-[#F7F1EE]'}`}
      data-testid={`nav-${icon}`}
      aria-label={icon}
    >
      {icons[icon]}
    </button>
  );
};

export const BottomNav = ({ currentPage = 'home' }) => {
  const navigate = useNavigate();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40"
      style={{ background: 'linear-gradient(to top, #FBF9F6 0%, #FBF9F6 75%, transparent 100%)', paddingTop: '20px' }}
    >
      <div className="max-w-md mx-auto px-6 pb-5">
        <div
          className="flex items-center justify-around py-2.5 px-4 rounded-2xl"
          style={{
            backgroundColor: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(12px)',
            border: '1px solid #EAE4DC',
            boxShadow: '0 4px 20px rgba(26,26,46,0.06)',
          }}
        >
          <NavButton icon="home" active={currentPage === 'home'} onClick={() => navigate('/sanctuary')} />
          <NavButton icon="journal" active={currentPage === 'journal'} onClick={() => navigate('/journal')} />
          <NavButton icon="sage" center onClick={() => navigate('/chat')} />
          <NavButton icon="progress" active={currentPage === 'progress'} onClick={() => navigate('/progress')} />
          <NotificationBell />
          <NavButton icon="settings" active={currentPage === 'settings'} onClick={() => navigate('/settings')} />
        </div>
      </div>
    </nav>
  );
};
